import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface NavInfoState {
  firstLevelStatus: number;
  secondLevelStatus: number;
  taskUserList: number[];
  isWorldLegend: boolean;
}

const localGameInfo = LocalStore.getValue<NavInfoState>('NAV_INFO_STATE') || {};

export const navInfo: NavInfoState = {
  firstLevelStatus: 0,
  secondLevelStatus: 0,
  taskUserList: [],
  isWorldLegend: false,
  ...localGameInfo
};

export const setNavInfoState: (payload: NavInfoState) => IAction<NavInfoState> = (payload: NavInfoState) => ({
  type: 'setNavInfoState',
  payload
});

const liveReducer: Reducer<NavInfoState, IAction<any>> = (state = navInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setNavInfoState':
      LocalStore.setValue('NAV_INFO_STATE', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default liveReducer;
